import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import OtpInitialValues from "../../../entities/OtpInitialValues";
import RenderInputError from "../../Login/RenderInputError/RenderInputError";
import NextStepButton from "../../../components/NextStepButton/NextStepButton";
import { OtpVerifyRegister } from "../../../services/OtpVerifyRegister";
import { useDispatch, useSelector } from "react-redux";
import CircleLoading from "../../../components/CircleLoading/CircleLoading";
import {
  OtpSendRegister,
  otpSendRegisterUtil,
} from "../../../services/OtpSendRegister";
import "./RegSecondStep.scss";
import { isEnterPress } from "../../../utils/helpers/accessibilityUtil";
import { otpVerifyUtil } from "../../../services/OtpVerify";
import CustomInput from "../../../components/CustomInput/CustomInput";
import { CountdownCircleTimer } from "react-countdown-circle-timer";

import { waitimgTimeToSendAgaininMiliSeconds, waitimgTimeToSendAgainInSECONDS } from "../../../pages/Login/Login";

import { suspensionTimeInMiliseconds } from "../../../components/Otp/Otp";
import RenderTime from "../../../components/LoderCountdown/LoderCountdown";
import {
  setHaveMessages,
  setIsAmit,
  setIsOnline,
  setIsPensioner,
  setIsSendAgainPossible,
  setIsSendAgainPossibleDate,
  setIsSuspend,
  setMapUserFunds,
  setUserFirstName,
  setUserFunds,
  setUserLastName,
} from "../../../state/actions/UserActions";
const RegSecondStep = (props: {
  setActiveStep: (arg0: number) => void;
  activeStep: number;
}) => {
  const { t } = useTranslation("common");
  const { userId, idDate } = useSelector((state: any) => state.UserReducer);
  const [loading, setLoading] = useState<boolean>(false);
  const [isOtpError, setOtpError] = useState<boolean>(false);
  const [isSendAgainError, setSendAgainError] = useState<boolean>(false);
  const [isMaxServerRequestsError, setMaxServerRequestsError] =
    useState<boolean>(false);
  const [otpMode, setOtpMode] = useState<number>(0);
  const [otpContactValue, setOtpContactValue] = useState<string>("");
  const [isSendAgainPossibleTimeLeft, setisSendAgainPossibleTimeLeft] = useState<number>(waitimgTimeToSendAgainInSECONDS);
  const dispatch = useDispatch();
  const { isSuspend, isSendAgainPossible } = useSelector((state: any) => state.UserReducer)
  const { isSendAgainPossibleDate } = useSelector((state: any) => state.UserReducer);

  const validate = (values: OtpInitialValues) => {
    const errors: any = {};

    if (!values.enteredOtpCode) {
      errors.enteredOtpCode = t("Otp.inputNullError");
    } else if (values.enteredOtpCode.length !== 6) {
      errors.enteredOtpCode = t("Otp.inputError");
    } else if (
      // check for every digit that is a number
      values.enteredOtpCode
        .split("")
        .filter((digit: string) => parseInt(digit) >= 0 && parseInt(digit) <= 9)
        .length !== 6
    ) {
      errors.enteredOtpCode = t("Otp.inputError");
    } else if (
      // handle all zeros case
      values.enteredOtpCode
        .split("")
        .filter((digit: string) => parseInt(digit) === 0).length === 6
    ) {
      errors.enteredOtpCode = t("Otp.inputError");
    }

    if(isMaxServerRequestsError)
    {
      errors.enteredOtpCode =  t("Otp.codeNotValid");
    }  
   
    return errors;
  };

  const formik: any = useFormik({
    initialValues: {
      enteredOtpCode: "",
    },
    validate,
    onSubmit: async (values: OtpInitialValues) => {
      if (values) {
      
        // in screen the fields start from right to left ..
        setLoading(true);
        const token = await OtpVerifyRegister(userId, values.enteredOtpCode);
        if (otpVerifyUtil.isSuccess(token)) {
        
          sessionStorage.setItem("token", token);
          props.setActiveStep(props.activeStep + 1);
        } else if (otpVerifyUtil.isMaxServerRequestsError(token)) {
         
          isOtpError && setOtpError(false);
          isSendAgainError && setSendAgainError(false);
          setMaxServerRequestsError(true);
        } else {          
          const timeToSendAgainPosibbleInSeconds = (isSendAgainPossibleDate.getTime() - new Date().getTime()) / 1000
          setisSendAgainPossibleTimeLeft(timeToSendAgainPosibbleInSeconds)
          isSendAgainError && setSendAgainError(false);
          isMaxServerRequestsError && setMaxServerRequestsError(false);
          setOtpError(true);
        }
        setLoading(false);
      }
    },
  });

  const getSendAgainSuspensionStatus = () => {
    // return true if sendAgainSuspensionDate is exist in local storage and
    // current date is bigger than suspension date

    const sendAgainSuspensionDate = localStorage.getItem(
      "sendAgainSuspensionDate"
    );
    const currentDate = new Date();
    return (
      sendAgainSuspensionDate &&
      currentDate >= new Date(sendAgainSuspensionDate)
    );
  };

  const setSuspensionDate = () => {
    const suspensionDate = new Date();
    suspensionDate.setMinutes(suspensionDate.getMinutes() + 10);
    localStorage.setItem("sendAgainSuspensionDate", suspensionDate.toString());
  };

  const getSendAgainCount = () => {
    const sendAgainCount = sessionStorage.getItem("sendAgainCount");
    const isUserSuspended = getSendAgainSuspensionStatus();
    if (!sendAgainCount || isUserSuspended) {
      isUserSuspended && localStorage.removeItem("sendAgainSuspensionDate");
      return 0;
    } else if (parseInt(sendAgainCount) === 5) {
      setSuspensionDate();
    }
    return parseInt(sendAgainCount);
  };

  const sendAgainOtpCode = async () => {
   
    resetOtpFields();
    isOtpError && setOtpError(false);
    isMaxServerRequestsError && setMaxServerRequestsError(false);
    let sendAgainCount = getSendAgainCount();
    if (sendAgainCount < 5) {
      setLoading(true);
      sendAgainCount++;
      sessionStorage.setItem("sendAgainCount", `${sendAgainCount}`);
      const isValidNewCode = await OtpSendRegister(userId, idDate);
     // console.log("isValidNewCode",isValidNewCode);
      
      if (!otpSendRegisterUtil.isSuccess(isValidNewCode)) {
       
        // TODO: TBD with amitim about error codes from api service
        setSendAgainError(true);
      }
      if (otpSendRegisterUtil.isSuccess(isValidNewCode) && isSendAgainError) {
        // case if sendAgainError is true, clean up.
        if (otpSendRegisterUtil.isMaxServerRequestsError(isValidNewCode)) {
          dispatch(setIsSuspend(true))
        
          setTimeout(() => dispatch(setIsSuspend(false)), suspensionTimeInMiliseconds)
        }
        setSendAgainError(false);
      }
    } else {
      setMaxServerRequestsError(true);
    }
    
    let date = new Date()
    date.setSeconds(date.getSeconds() + waitimgTimeToSendAgainInSECONDS);
    dispatch(setIsSendAgainPossibleDate(date))
    dispatch(setIsSendAgainPossible(false))
    setTimeout(() => dispatch(setIsSendAgainPossible(true)), waitimgTimeToSendAgaininMiliSeconds)
    setisSendAgainPossibleTimeLeft(waitimgTimeToSendAgainInSECONDS)
    setLoading(false);
  };

  const resetOtpFields = () => {
    formik.resetForm();
  };

  const setOtpValues = () => {
    const otpMode = sessionStorage.getItem("otpMode");
    const cellPhoneNumber = sessionStorage.getItem("cellPhoneNumber");
    const email = sessionStorage.getItem("email");
    otpMode && setOtpMode(parseInt(otpMode));
    cellPhoneNumber && setOtpContactValue(cellPhoneNumber);
    email && setOtpContactValue(email);
  };
  

  const getEncodedCellphone = () => {
    let cellPhoneNumber = sessionStorage.getItem("cellPhoneNumber");
    if (otpContactValue?.length && cellPhoneNumber) {
      let formatCellphoneNumber = !cellPhoneNumber.includes("-")
        ? insert(cellPhoneNumber, 3, "-")
        : cellPhoneNumber;
      formatCellphoneNumber = replaceRange(
        formatCellphoneNumber,
        6,
        formatCellphoneNumber.length - 1,
        "XXXX"
      );
      return formatCellphoneNumber;
    }
    return "";
  };

  const getEncodedEmail = () => {
    if (otpContactValue?.length) {
      const indexIndicator = otpContactValue.indexOf("@");
      return replaceRange(
        otpContactValue,
        indexIndicator - 4,
        indexIndicator,
        "XXXX"
      );
    }
    return "";
  };

  function insert(str: any, index: number, value: any) {
    if (str && value) {
      return str.substr(0, index) + value + str.substr(index);
    }
    return "";
  }

  function replaceRange(
    s: any,
    start: number,
    end: number,
    substitute: string
  ) {
    if (s && substitute) {
      return s.substring(0, start) + substitute + s.substring(end);
    }
    return "";
  }

  useEffect(() => {
    setOtpValues();
    setTimeout(() => dispatch(setIsSendAgainPossible(true)), waitimgTimeToSendAgaininMiliSeconds)


  }, []);

  return loading ? (
    <CircleLoading />
  ) : (
    <form onSubmit={formik.handleSubmit}>
      <div className="reg-second-main-text">
        {t("RegSecondStep.mainText1")} <br/>
        {!otpMode ? (
          <>
            {`${t("RegSecondStep.toYourEmail")} `}
            {getEncodedEmail()}
          </>
        ) : (
          <>
            {`${t("RegSecondStep.toYourCellphone")} `}
            {getEncodedCellphone()}
          </>
        )}
        <br/>{t("RegSecondStep.mainText2")},
        <br/>{t("RegSecondStep.mainText3")}
      </div>
      <div className="wrap-inputs">
        <CustomInput
        ariaDescription="הקוד תקף ל-דקה 1 בלבד"
          formik={formik}
          fullWidth={true}
          keyString="enteredOtpCode"
          inputLabel={`${t("Otp.inputLabel")}*`}
          tooltipLabel={t("Otp.tooltipLabel")}
          withIcon={true}
          withTooltip={true}
          maxLength={6}
          autoFocus={true}
        />
        <div className="error-box">
        {(isOtpError || isSendAgainError || isMaxServerRequestsError) && (
        <div >
          <RenderInputError
            errorLabel={
              isSendAgainError
                ? t("Otp.sendAgainError")
                : isMaxServerRequestsError
                ? t("BankAccountVerify.sendAgainError")
                : t("Otp.codeNotValid")
            }
          />
        </div>
        )}
        </div>
      </div>
      <div className="otp-final-labels-wrapper">
        
         
         
      {(!isSendAgainPossible )? //|| (!isSendAgainPossible && isSuspend)   
           
              <div className="timer-wrapper">
                <CountdownCircleTimer
                  strokeWidth={8}
                  size={50}
                  isPlaying                
                  duration={waitimgTimeToSendAgainInSECONDS}
                  initialRemainingTime={isSendAgainPossibleTimeLeft}
                  colors={["#0250C1", "#80a2ff", "#a5bdff"]}
                  colorsTime={[isSendAgainPossibleTimeLeft / 2, 0]}
                >
                  {RenderTime}
                </CountdownCircleTimer>
                {t("Login.codeOneTheWay")}
              </div>
            
           :   
            <>
            <u
            onClick={()=>sendAgainOtpCode()}
            onKeyPress={(event) => isEnterPress(event) && sendAgainOtpCode()}
            tabIndex={0}
            >
            {t("Otp.sendAgainCode")}
          </u>
  
           </>
           } 
      </div>
      <NextStepButton text={t("general.next")} onclick={()=>{}}/>
    </form>
  );
};

export default RegSecondStep;
